/* This file is autogenerated, see readme.md for instructions */
import PlusSvgIcon from '@bloomreach/banana-theme/icons/plus.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const PlusIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <PlusSvgIcon />
    </Icon>
  );
});

PlusIcon.displayName = 'PlusIcon';

export default PlusIcon;
